import type Phaser from 'phaser';
import type { DebugSnapshot } from '../../core';

const COLORS = Object.freeze({ PUSH: 0x4ade80, HURT: 0x60a5fa, HIT: 0xfb7185, TRAP: 0xc084fc });

export class DebugOverlay {
  private readonly graphics: Phaser.GameObjects.Graphics;
  private enabled: boolean;
  public constructor(scene: Phaser.Scene, enabled = import.meta.env.DEV && new URLSearchParams(globalThis.location.search).get('debug') === 'true') {
    this.graphics = scene.add.graphics().setDepth(1_000); this.enabled = enabled;
  }
  public render(snapshot: DebugSnapshot): void {
    this.graphics.clear(); this.graphics.setVisible(this.enabled); if (!this.enabled) return;
    for (const entry of snapshot.boxes) {
      this.graphics.lineStyle(2, COLORS[entry.type], 0.9);
      this.graphics.strokeRect(entry.box.minX, entry.box.minY, entry.box.maxX - entry.box.minX, entry.box.maxY - entry.box.minY);
    }
    for (const origin of snapshot.origins) this.graphics.fillStyle(0xfacc15).fillCircle(origin.x, origin.y, 4);
  }
  public toggle(): void { this.enabled = !this.enabled; }
  public dispose(): void { this.graphics.destroy(); }
}
